function abrirImprimir(url){

    const nuevaVentana = window.open(url,'_blank');

    nuevaVentana.onload = function(){
        nuevaVentana.print();

        nuevaVentana.onafterprint = function(){
            nuevaVentana.close();
        };
    };
}